export default function ImagePreviewModal({ open, imageUrl, onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="relative max-w-[90vw] max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 bg-white rounded-full w-8 h-8 flex items-center justify-center shadow"
        >
          ✕
        </button>

        {/* Full Image */}
        <img
          src={imageUrl}
          alt="Preview"
          className="max-w-full max-h-[90vh] rounded-lg object-contain"
        />
      </div>
    </div>
  );
}
